// src/screens/ItineraryWizard.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addDays } from 'date-fns';

import { useItinerary } from '../hooks/useItinerary';
import { obtenerItinerario } from '../api/api';

import StepProfile   from './stepProfile';
import StepDates     from './stepDates';
import StepDayPoints from './stepStartPoint';      // ← NUEVO

/* ------------------------------------------------------------ */
type Step = 0 | 1 | 2;   // 0-Fechas · 1-Perfil · 2-DayPoints
/* ------------------------------------------------------------ */

const ItineraryWizard: React.FC = () => {
  /* ---------- contexto global ---------- */
  const {
    setItinerarios,
    setPerfil      : setPerfilCtx,
    setDias,
    dayPoints,
    setDayPoints,
  } = useItinerary();

  const navigate = useNavigate();

  /* ---------- estado local ------------- */
  const [step, setStep] = useState<Step>(0);

  const [perfil, setPerfilLocal] = useState('');
  const [dateRange, setDateRange] = useState<{ start: Date; end: Date }>({
    start: new Date(),
    end  : addDays(new Date(), 1),
  });
  const [daysArray, setDaysArray] = useState<number[]>([]); // [1,2,3…]
  const [loading,   setLoading]   = useState(false);

  /* ---------- paso final --------------- */
  const finish = async () => {
    setLoading(true);
    try {
      /* 1) guardar datos en contexto */
      setPerfilCtx(perfil);
      setDias(daysArray.length);

      /* 2) pedir itinerario */
      const data = await obtenerItinerario(perfil, daysArray.length);
      setItinerarios(data);

      /* 3) navegar al mapa */
      navigate('/map', {
        state: {
          fechaInicio: dateRange.start.toISOString().slice(0, 10),
          fechaFin   : dateRange.end.toISOString().slice(0, 10),
        },
      });
    } catch {
      alert('Ocurrió un error al generar el itinerario.');
    } finally {
      setLoading(false);
    }
  };

  /* ---------- render por paso ---------- */
  return (
    <div>
      {/* PASO 0 · Fechas ------------------------------------------------ */}
      {step === 0 && (
        <StepDates
          dateRange={dateRange}
          setDateRange={setDateRange}
          onNext={(diasSeleccionados) => {
            setDaysArray(diasSeleccionados);       // [1,2,3…]
            setDias(diasSeleccionados.length);     // contexto
            setStep(1);
          }}
        />
      )}

      {/* PASO 1 · Perfil ------------------------------------------------ */}
      {step === 1 && (
        <StepProfile
          perfil={perfil}
          setPerfil={setPerfilLocal}
          onBack={() => setStep(0)}
          onNext={() => setStep(2)}
        />
      )}

      {/* PASO 2 · Inicio / Fin por día --------------------------------- */}
      {step === 2 && (
        <StepDayPoints
          days={daysArray}
        
         
          onBack={() => setStep(1)}
          onFinish={finish}
          loading={loading}
        />
      )}
    </div>
  );
};

export default ItineraryWizard;
